
"use strict";

var app = angular.module('tabletApp', [
    'ngRoute',
    'ngCookies',
    'ngSanitize',
    'LocalStorageModule',
    'angular-hal',
    'angularNumberPicker',
    'cache.interceptor',
    'ng-sortable',
    'pascalprecht.translate',
    'ngSanitize',

    'tablet.settings',
    'provider.configuration',
    'filters',
    'serviceRequestControllers',
    'controller.Login',
    'controller.metadata',

    'controllers.service.widgets.create',
    'controllers.service.widgets.signin',
    'controllers.service.widgets.view',
    'controllers.service.widgets.signout',
    'controllers.impersonation',

    'service.Authentication',
    'service.ServiceRequest',
    'service.User',
    'service.Store',
    'service.Clock',
    'service.LookUp',
    'service.CommonFault',
    'service.Wiki',
    'service.MetaData',
    'service.ChangePasswordRequest',
    'service.Language',
    'service.SSE',
    'service.impersonation',
    'tmh.dynamicLocale',
    'commonDirectives',
    'listDirectives',
    'ui.bootstrap',
    'NgSwitchery',
    'NgDrawing',
    'signatureDirective',
    'dateTimePickerDirective',
    'authenticateFormDirective',
    'managerSelectFormDirective',
    'angular.filter',
    'ui-notification'
]);

app.config(['$routeProvider', '$locationProvider', '$httpProvider', 'localStorageServiceProvider', '$translateProvider', 'tmhDynamicLocaleProvider', 'NotificationProvider', function ($routeProvider, $locationProvider, $httpProvider, localStorageServiceProvider, $translateProvider, tmhDynamicLocaleProvider, NotificationProvider) {

    $httpProvider.interceptors.push('cacheBusterInterceptor');

    localStorageServiceProvider
        .setPrefix('tabletApp')
        .setStorageType('localStorage');

    // call to /gf-servicemanager-api/i18nTable?lang=en
    $translateProvider.preferredLanguage('en_GB');
    $translateProvider.useUrlLoader('/gf-servicemanager-api/i18nTable');
    $translateProvider.useSanitizeValueStrategy('sanitizeParameters');

    // Used for Datetime and Number formats
    tmhDynamicLocaleProvider.localeLocationPattern('bower_components/angular-i18n/angular-locale_{{locale}}.js');

    $routeProvider.when('/service-request-list', {
        templateUrl: 'js/views/serviceRequestList.html'
    });

    $routeProvider.when('/service-request-create', {
        templateUrl: 'js/views/service-creation/create.html'
    });

    $routeProvider.when('/service-request-view/:serviceRequestId', {
        templateUrl: 'js/views/view/view.html'
    });

    $routeProvider.when('/service-request-signin/:serviceRequestId', {
        templateUrl: 'js/views/signin/signin.html'
    });

    $routeProvider.when('/service-request-signout/:serviceRequestId', {
        templateUrl: 'js/views/signout/signout.html'
    });

    $routeProvider.when('/test', {
        templateUrl: 'js/views/signin/storeSignatureWithSample.tpl.html'
    });

    $routeProvider.when('/impersonate', {
        templateUrl: 'js/views/impersonate.html'
    });

    $routeProvider.otherwise({
        redirectTo: '/service-request-list'
    });

    NotificationProvider.setOptions({
        delay: 10000,
        startTop: 20,
        startRight: 10,
        verticalSpacing: 20,
        horizontalSpacing: 20,
        positionX: 'left',
        positionY: 'bottom'
    });

}]);

// In order to clear app storage and force re-authentication against the store and user bump the 'currentAppVersion'
app.run(['localStorageService', 'storageKeys','$rootScope','$log', function(localStorageService, storageKeys, $rootScope, $log){
    $log.debug("App run")

    // used to control visibility of the service request list
    $rootScope.serviceRequestList = {
        show : false
    };

    $rootScope.loginScreen = {
        show : true
    };

    $rootScope.impersonation = false;

    // Stored directly on the root scope as current html layout prevents better implementation
    $rootScope.store = null
    $rootScope.returnToMainScreen =function () {
        $rootScope.$broadcast("event:return-main-screen")
    };

    var currentAppVersion = "1";
    var appVersion = localStorageService.get(storageKeys.appVersion);
    if(appVersion !== currentAppVersion){
        localStorageService.clearAll();
        localStorageService.add(storageKeys.appVersion, currentAppVersion)
    }
}]);

angular.element(document).ready(function () {
    var configurationUrl = "/gf-servicemanager-api/api/apiversion/1"
    $.get(configurationUrl)
        .done(function (data) {
            angular.module('provider.configuration').config(['configurationProvider', function (configurationProvider) {
                configurationProvider.configure(data)
            }])
        })
        .always(function () {
            angular.bootstrap(document, ['tabletApp']);
            // as we manually bootstrap the app, uninitialized application UI is visible on start
            // to prevent that, only background element is not hidden on start, then
            // when configuration is loaded the UI is shown
            $("#login-holder .cls-content").removeClass("hidden")
            $("#container").removeClass("hidden")
        })
});